<template>
  <el-container v-if="user" class="custom-app vh-100">
    <el-container>
      <el-aside width="auto">
        <el-menu router :default-active="$route.path" :collapse="isCollapse" class="el-menu-vertical">
          <router-link :to="{ name: 'Home' }" class="aside__logo">
            <img src="@/assets/images/logo.svg" alt="logo" />
          </router-link>
          <template v-for="item of menuItems">
            <el-submenu v-if="item.subItems" :index="item.key" :key="item.key">
              <template slot="title">
                <component v-if="item.iconComponent" v-bind:is="item.iconComponent" class="mr-3" />
                <span slot="title">{{ item.name }}</span>
              </template>
              <el-menu-item v-for="subItem of item.subItems" :index="'/' + subItem.key" :key="subItem.key" style="padding-left: 24px">
                <component v-if="subItem.iconComponent" v-bind:is="subItem.iconComponent" class="mr-3" />
                <span slot="title">{{ subItem.name }}</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item v-else :index="'/' + item.key" :key="item.key">
              <component v-if="item.iconComponent" v-bind:is="item.iconComponent" class="mr-3" />
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header class="d-flex align-items-center">
          <div class="pointer" @click="toggleCollapse">
            <IconMenu />
          </div>
          <div class="ml-auto d-flex">
<!--            <div class="mr-5">{{ user.id }}</div>-->
            <div class="pointer" @click="onLogout">
              <IconLogout />
            </div>
          </div>
        </el-header>

        <el-main class="bg-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IconMenu from '@/components/ui/icons/IconMenu';
import IconLogout from '@/components/ui/icons/IconLogout';
import IconRun from '@/components/ui/icons/IconRun';
import IconContentSettings from '@/components/ui/icons/IconContentSettings';
import { NO_ACCESS_MESSAGE } from '@/commons/constants/errorMessages';
import menuItems from '@/commons/menuItems';

export default {
  components: {
    IconMenu,
    IconLogout,
    IconRun,
    IconContentSettings,
  },
  data: () => ({
    NO_ACCESS_MESSAGE,
    isCollapse: document.documentElement.clientWidth < 992,
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    menuItems() {
      return menuItems;
    },
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    onLogout() {
      this.logout().finally(() => {
        this.$router.push('/login');
      });
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>

<style>
.el-menu-vertical:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
</style>
